import { translate } from 'components/translate-hoc';
import AddMetaDescription from './add-meta-description.component';

export default translate()(AddMetaDescription);
